<template>
    <div>
        <div class="show-navigation body--secondary">
            <div class="body--secondary__wrapper mb--md animated fadeIn">
                <header class="header">
                    <div class="container">
                        <div class="row align-items--center">
                            <div class="col-2">
                                <a @click.prevent="handleBack('/')" class="btn btn--icon btn--white">
                                    <i class="material-icons">keyboard_arrow_left</i>
                                </a>
                            </div>

                            <div class="col-8">
                                <h1 class="header__title">Profile</h1>
                            </div>
                        </div>
                    </div>
                </header>

                <section class="card card--expanded avatar-wrapper pb--30 mb--sm">
                    <div class="container">
                        <div class="profile profile--lg profile--vertical mb--30">
                            <figure class="profile__avatar mb--0">
                                <span class="profile__avatar__img">
                                    <img :src="user.avatar" v-if="isLoggedIn" />
                                    <img src="/img/pictures/avatar-1.jpg" v-else />
                                </span>
                            </figure>

                            <div class="profile__text" v-if="isLoggedIn">
                                <div class="profile__name" mb--0>{{ user.nick }}</div>
                                <div class="profile__level">
                                    <strong>{{ user.name }}</strong>
                                </div>
                            </div>
                            <div class="profile__text" v-else>
                                <div class="profile__name">Guest</div>
                                <div class="profile__level">
                                    <strong>Guest</strong>
                                </div>
                            </div>
                        </div>

                        <div class="row justify-content--center">
                            <div class="col-4">
                                <router-link to="profile/settings" class="btn btn--block btn--white btn--top-icon">
                                    <i class="material-icons">settings</i>
                                    Settings
                                </router-link>
                            </div>

                            <div class="col-4">
                                <router-link to="statistics" class="btn btn--block btn--white btn--top-icon">
                                    <svg class="icon"><use xlink:href="/img/icon-sprite.svg#statistic"></use></svg>
                                    Statistics
                                </router-link>
                            </div>

                            <div class="col-4">
                                <a @click="openDiscountModal" class="btn btn--block btn--white btn--top-icon">
                                    <svg class="icon"><use xlink:href="/img/icon-sprite.svg#coupon"></use></svg>
                                    Add coupon

                                    <discount-modal ref="discountModal"></discount-modal>
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <article class="card card--expanded mb--md" v-show="user.badges">
                <h2 class="title-primary text--center">Badges</h2>

                <div class="swiper-container iconbox-carousel mb--sm">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="badge in user.badges">
                            <div class="iconbox">
                                <img :src="badge.image" v-bind:alt="badge.name" />
                                <span>{{ badge.name }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </article>

            <article class="card card--expanded mb--md">
                <h2 class="title-primary text--center">Achievements</h2>

                <div class="swiper-container iconbox-carousel mb--sm">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="achievement in achievements">
                            <div class="iconbox">
                                <img :src="achievement.image" :alt="achievement.name" />
                                <span>{{ achievement.name }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </div>

        <navigation></navigation>
    </div>
</template>

<script>
import Navigation from "../partial/Navigation";
import {mapGetters} from 'vuex'
import internalBackRoute from "../../mixins/internalBackRoute";
import DiscountModal from "./DiscountModal";
import api from "../../api/profile"
import Swiper from "swiper";

export default {
    name: "Profile",
    components: {Navigation, DiscountModal},
    mixins: [internalBackRoute],

    computed: {
        ...mapGetters('auth', [
            'user',
            'isLoggedIn',
        ]),
    },

    created() {
        this.loadUserAchievements()
    },

    data: function () {
        return {
            achievements: [],
            swiper: null
        }
    },

    methods: {
        openDiscountModal() {
            this.$refs.discountModal.open()
        },

        async loadUserAchievements() {
            try {
                let response = await api.loadUserAchievements()

                this.achievements = response.data.data
                this.createSwiper()
            } catch (e) {
            }
        },

        createSwiper() {
            if (! this.swiper) {
                this.$nextTick(function () {
                    this.swiper = new Swiper('.iconbox-carousel', {
                        loop: true,
                        slidesPerView: 3,
                        centeredSlides: true,
                    })
                })
            }
        }
    }
}
</script>
